export function tlTime(duration: number): string {
  const minutes = Math.floor(duration / 60);
  const seconds = Math.floor(duration - minutes * 60);
  const mSeconds = duration - Math.floor(duration);
  const min = minutes < 10 ? `0${minutes}` : String(minutes);
  const sec = seconds < 10 ? `0${seconds}` : String(seconds);
  const ms = String(mSeconds.toFixed(3)).split('.')[1];
  return `${min}:${sec},${ms}`;
}
